var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-layout", { staticClass: "headline" }, [
        _vm._v(_vm._s(_vm.$t("PromotionSchedule")))
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c(
                "v-btn",
                {
                  staticClass: "add",
                  attrs: { dark: "", color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditPromotionDialog({})
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("add")))]
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-2 myDense",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.promotions,
                  "item-key": "key",
                  pagination: _vm.pagination,
                  expand: _vm.expand
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          {
                            on: {
                              click: function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          },
                          [
                            _c("td", { staticClass: "subheading" }, [
                              _vm._v(
                                _vm._s(_vm.toDateString(props.item.startDate))
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "subheading" }, [
                              _vm._v(
                                _vm._s(_vm.toDateString(props.item.endDate))
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "subheading" }, [
                              _vm._v(_vm._s(props.item.title))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-layout",
                                  [
                                    _c(
                                      "v-flex",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              dark: "",
                                              color: "primary",
                                              flat: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.showEditPromotionDialog(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("edit")))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              dark: "",
                                              color: "secondary",
                                              flat: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.deletePromotion(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("delete")))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "expand",
                    fn: function(props) {
                      return [
                        _c(
                          "v-card",
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-center": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { sm6: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { sm7: "" } },
                                              _vm._l(
                                                props.item.tierDeposits,
                                                function(item, index) {
                                                  return _c(
                                                    "v-layout",
                                                    {
                                                      key: index,
                                                      attrs: {
                                                        "justify-start": "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-flex", [
                                                        _c("b", [
                                                          _vm._v(
                                                            "≥ $" +
                                                              _vm._s(
                                                                item.threshold
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$t("bonus")
                                                              ) +
                                                              ": "
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "$" +
                                                            _vm._s(item.bonus) +
                                                            " "
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-spacer"),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { sm5: "" } },
                                              [
                                                _c(
                                                  "v-layout",
                                                  { attrs: { column: "" } },
                                                  [
                                                    _c("div", [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("note")
                                                          ) + ":"
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          whiteSpace:
                                                            "pre-wrap",
                                                          "overflow-wrap":
                                                            "break-word",
                                                          "max-width": "30vw"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.note
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.editPromotionDialog
        ? _c("PromotionEdit", {
            attrs: {
              title: _vm.$t("Promotions"),
              actionFunc: _vm.editPromotionFunc,
              promotion: _vm.promotionInEdit
            },
            model: {
              value: _vm.editPromotionDialog,
              callback: function($$v) {
                _vm.editPromotionDialog = $$v
              },
              expression: "editPromotionDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c46f1234", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c46f1234","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PromotionSettings.vue
// module id = null
// module chunks = 